class ProductConfigurator {
  constructor() {
    this.form = document.querySelector('[data-configurator-form]');
    this.summary = document.querySelector('[data-configurator-summary]');
    this.summaryItems = document.querySelector('[data-summary-items]');
    this.totalPrice = document.querySelector('[data-total-price]');
    this.addToCartBtn = document.querySelector('[data-add-to-cart]');
    this.errorMessage = document.querySelector('[data-error-message]');
    this.mainImageContainer = document.querySelector('[data-main-image]');
    
    // Load compatibility data from global window object
    this.compatibilityData = window.configuratorCompatibilityData || [];
    
    // Forend position adjustments based on chassis selection

    this.forendPositionConfig = window.configuratorForendPositionConfig || {};
    
    // Grip position adjustments based on interface selection (step 2)
    this.gripPositionConfig = {
      "114597": { x: 20, y: 0 },
      "114622": { x: 23, y: 1 }
    };
    
    // Store selections for each step
    this.selections = {
      1: null, // Step 1: required
      2: null, // Step 2: required
      3: null, // Step 3: optional
      4: null, // Step 4: optional
      5: null  // Step 5: optional
    };
    
    this.init();
  }
  
  init() {
    if (!this.form) return;
    
    // Add event listeners to tab buttons
    const tabButtons = document.querySelectorAll('.tab-button');
    tabButtons.forEach(button => {
      button.addEventListener('click', this.handleTabClick.bind(this));
    });
    
    // Add event listeners to tab navigation arrows
    const prevArrow = document.querySelector('.tab-nav-prev');
    const nextArrow = document.querySelector('.tab-nav-next');
    if (prevArrow) {
      prevArrow.addEventListener('click', this.handlePrevTab.bind(this));
    }
    if (nextArrow) {
      nextArrow.addEventListener('click', this.handleNextTab.bind(this));
    }
    
    // Update arrow states
    this.updateTabArrows();
    
    // Add scroll listener to tabs container for swipe/scroll detection
    const tabsContainer = document.querySelector('.configurator-tabs');
    if (tabsContainer) {
      let scrollTimeout;
      tabsContainer.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          this.handleTabsScroll(tabsContainer);
        }, 150);
      });
    }
    
    // Add event listeners to variant navigation arrows
    const variantNavArrows = document.querySelectorAll('.variant-nav-arrow');
    variantNavArrows.forEach(arrow => {
      arrow.addEventListener('click', this.handleVariantNavClick.bind(this));
    });
    
    // Add event listeners to all color radios
    const colorRadios = this.form.querySelectorAll('.color-radio');
    colorRadios.forEach(radio => {
      radio.addEventListener('change', this.handleColorChange.bind(this));
    });
    
    // Add event listeners to all variant radios
    const variantRadios = this.form.querySelectorAll('.variant-radio');
    variantRadios.forEach(radio => {
      radio.addEventListener('change', this.handleVariantChange.bind(this));
    });
    
    // Add event listener to Add to Cart button
    if (this.addToCartBtn) {
      this.addToCartBtn.addEventListener('click', this.handleAddToCart.bind(this));
    }

    // Add event listener to clear buttons
    const clearButtons = this.form.querySelectorAll('.variant-clear-btn');
    clearButtons.forEach(btn => {
      btn.addEventListener('click', this.handleClearSelection.bind(this));
    });
    
    // Pre-select first color and variant in Step 1
    this.preselectStep1();
    
    // Initial render
    this.updateSummary();
  }
  
  preselectStep1() {
    // Pre-select first color for ALL steps
    for (let step = 1; step <= 5; step++) {
      const stepElement = this.form.querySelector(`[data-step="${step}"]`);
      if (!stepElement) continue;
      
      const firstColorRadio = stepElement.querySelector('.color-radio');
      if (firstColorRadio) {
        firstColorRadio.checked = true;
        // Don't trigger change event yet, just check it
      }
    }
    
    // Now trigger change for Step 1 color to show its variants
    const step1 = this.form.querySelector('[data-step="1"]');
    if (step1) {
      const firstColorRadio = step1.querySelector('.color-radio:checked');
      if (firstColorRadio) {
        firstColorRadio.dispatchEvent(new Event('change', { bubbles: true }));
        
        // Auto-select first variant in Step 1
        setTimeout(() => {
          const firstVariantRadio = step1.querySelector('.variant-radio:not([value="none"])');
          if (firstVariantRadio) {
            firstVariantRadio.checked = true;
            firstVariantRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 50);
      }
    }
    
    // Trigger change for Step 2 color to show its variants (but don't auto-select a variant)
    const step2 = this.form.querySelector('[data-step="2"]');
    if (step2) {
      const firstColorRadio = step2.querySelector('.color-radio:checked');
      if (firstColorRadio) {
        firstColorRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    
    // Pre-select "None" for optional steps 3-5
    for (let step = 3; step <= 5; step++) {
      const stepElement = this.form.querySelector(`[data-step="${step}"]`);
      if (stepElement) {
        const noneVariant = stepElement.querySelector('.variant-radio[value="none"]');
        if (noneVariant) {
          noneVariant.checked = true;
          noneVariant.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }
  
  handleTabClick(event) {
    const clickedButton = event.currentTarget;
    const tabNumber = parseInt(clickedButton.dataset.tab);
    
    // Update active tab button
    document.querySelectorAll('.tab-button').forEach(btn => {
      btn.classList.remove('active');
    });
    clickedButton.classList.add('active');
    
    // Update active step
    document.querySelectorAll('.configurator-step').forEach(step => {
      step.classList.remove('active');
    });
    const activeStep = document.querySelector(`.configurator-step[data-step="${tabNumber}"]`);
    if (activeStep) {
      activeStep.classList.add('active');
      
      // Check if a color is already selected, if not select the first one
      const selectedColor = activeStep.querySelector('.color-radio:checked');
      
      // For optional steps (3-5), always ensure the none variant option is visible
      const isOptional = tabNumber >= 3;
      if (isOptional) {
        const noneVariantGroup = activeStep.querySelector('[data-color-group="none"]');
        if (noneVariantGroup) {
          noneVariantGroup.style.display = 'flex';
        }
      }
      
      if (!selectedColor) {
        // For optional steps, skip the "none" color option and select first actual color
        const firstActualColor = activeStep.querySelector('.color-radio:not([value="none"])');
        if (firstActualColor) {
          firstActualColor.checked = true;
          firstActualColor.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else if (selectedColor.value === 'none') {
        // If "none" color is selected, select the first actual color instead to show variants
        const firstActualColor = activeStep.querySelector('.color-radio:not([value="none"])');
        if (firstActualColor) {
          firstActualColor.checked = true;
          firstActualColor.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        // Color is selected, but variants might be hidden - trigger color change to show them
        selectedColor.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    
    // Scroll the tab into view and update arrow states
    clickedButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    this.updateTabArrows();
  }
  
  handlePrevTab() {
    const activeButton = document.querySelector('.tab-button.active');
    if (!activeButton) return;
    
    const prevButton = activeButton.previousElementSibling;
    if (prevButton && prevButton.classList.contains('tab-button')) {
      prevButton.click();
    }
  }
  
  handleNextTab() {
    const activeButton = document.querySelector('.tab-button.active');
    if (!activeButton) return;
    
    const nextButton = activeButton.nextElementSibling;
    if (nextButton && nextButton.classList.contains('tab-button')) {
      nextButton.click();
    }
  }
  
  updateTabArrows() {
    const activeButton = document.querySelector('.tab-button.active');
    const prevArrow = document.querySelector('.tab-nav-prev');
    const nextArrow = document.querySelector('.tab-nav-next');
    
    if (!activeButton || !prevArrow || !nextArrow) return;
    
    // Disable prev arrow if on first tab
    const prevButton = activeButton.previousElementSibling;
    prevArrow.disabled = !prevButton || !prevButton.classList.contains('tab-button');
    
    // Disable next arrow if on last tab
    const nextButton = activeButton.nextElementSibling;
    nextArrow.disabled = !nextButton || !nextButton.classList.contains('tab-button');
  }
  
  handleVariantNavClick(event) {
    const arrow = event.currentTarget;
    const step = arrow.dataset.step;
    const isPrev = arrow.classList.contains('variant-nav-prev');
    
    // Find the variant selector for this step
    const variantSelector = document.querySelector(`[data-step-variants="${step}"]`);
    if (!variantSelector) return;

    // Scroll the carousel to reveal next/prev variants without selecting them
    const scrollAmount = 300; // pixels to scroll

    if (isPrev) {
      variantSelector.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      variantSelector.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  }
  
  handleTabsScroll(tabsContainer) {
    // Find which tab button is most visible in the scroll viewport
    const containerRect = tabsContainer.getBoundingClientRect();
    const containerCenter = containerRect.left + containerRect.width / 2;
    
    const tabButtons = Array.from(document.querySelectorAll('.tab-button'));
    let closestTab = null;
    let closestDistance = Infinity;
    
    tabButtons.forEach(tab => {
      const tabRect = tab.getBoundingClientRect();
      const tabCenter = tabRect.left + tabRect.width / 2;
      const distance = Math.abs(containerCenter - tabCenter);
      
      if (distance < closestDistance) {
        closestDistance = distance;
        closestTab = tab;
      }
    });
    
    // Activate the closest tab if it's not already active
    if (closestTab && !closestTab.classList.contains('active')) {
      const targetStep = closestTab.dataset.tab;
      
      // Update active tab button
      tabButtons.forEach(btn => {
        btn.classList.remove('active');
      });
      closestTab.classList.add('active');
      
      // Update active step
      const steps = this.form.querySelectorAll('.configurator-step');
      steps.forEach(step => {
        step.classList.remove('active');
        if (step.dataset.step === targetStep) {
          step.classList.add('active');
          
          // Check if a color is already selected
          const selectedColor = step.querySelector('.color-radio:checked');
          const isOptional = parseInt(targetStep) >= 3;
          
          if (isOptional) {
            const noneVariantGroup = step.querySelector('[data-color-group="none"]');
            if (noneVariantGroup) {
              noneVariantGroup.style.display = 'flex';
            }
          }
          
          if (!selectedColor) {
            const firstActualColor = step.querySelector('.color-radio:not([value="none"])');
            if (firstActualColor) {
              firstActualColor.checked = true;
              firstActualColor.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else if (selectedColor.value === 'none') {
            const firstActualColor = step.querySelector('.color-radio:not([value="none"])');
            if (firstActualColor) {
              firstActualColor.checked = true;
              firstActualColor.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else {
            selectedColor.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
      
      // Update arrow states
      this.updateTabArrows();
    }
  }
  
  handleColorChange(event) {
    const radio = event.target;
    const step = parseInt(radio.dataset.step);
    const colorValue = radio.value;
    
    // Find the variant selector for this step
    const stepElement = radio.closest('.configurator-step');
    const variantSelector = stepElement.querySelector('[data-step-variants]');
    
    // Get currently selected variant SKU (if any)
    const currentlySelectedVariant = stepElement.querySelector('.variant-radio:checked');
    let currentSkuPrefix = null;
    if (currentlySelectedVariant && currentlySelectedVariant.dataset.variantSku) {
      const currentSku = currentlySelectedVariant.dataset.variantSku;
      // Extract SKU prefix (before the dash)
      currentSkuPrefix = currentSku.split('-')[0];
    }
    
    // Hide all variant groups except "none" for optional steps
    const allVariantGroups = variantSelector.querySelectorAll('.variant-options');
    allVariantGroups.forEach(group => {
      // Keep "none" option visible for optional steps (3-5)
      if (step >= 3 && group.dataset.colorGroup === 'none') {
        group.style.display = 'flex';
      } else {
        group.style.display = 'none';
      }
    });
    
    // Clear variant selection for this step
    const variantRadios = stepElement.querySelectorAll('.variant-radio');
    variantRadios.forEach(vr => {
      vr.checked = false;
    });
    
    // Handle "none" selection for optional steps
    if (colorValue === 'none') {
      this.selections[step] = null;
      // Re-filter to update incompatibilities
      this.filterIncompatibleVariants();
      return;
    }
    
    // Show the variant group for the selected color
    const colorHandle = colorValue.toLowerCase().replace(/\s+/g, '-');
    const selectedGroup = variantSelector.querySelector(`[data-color-group="${colorHandle}"]`);
    
    if (selectedGroup) {
      selectedGroup.style.display = 'flex';
      
      // Try to find variant with matching SKU prefix in the new color
      let matchingVariant = null;
      if (currentSkuPrefix) {
        const variantsInGroup = selectedGroup.querySelectorAll('.variant-radio');
        for (const variantRadio of variantsInGroup) {
          const sku = variantRadio.dataset.variantSku;
          if (sku) {
            const skuPrefix = sku.split('-')[0];
            if (skuPrefix === currentSkuPrefix) {
              matchingVariant = variantRadio;
              break;
            }
          }
        }
      }
      
      // Auto-select matching variant or first variant
      if (matchingVariant) {
        matchingVariant.checked = true;
        matchingVariant.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        // If no matching SKU, auto-select first variant if only one option
        const firstVariantRadio = selectedGroup.querySelector('.variant-radio');
        if (firstVariantRadio) {
          const variantCount = selectedGroup.querySelectorAll('.variant-radio').length;
          if (variantCount === 1) {
            firstVariantRadio.checked = true;
            firstVariantRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    }
  }
  
  handleVariantChange(event) {
    const radio = event.target;
    const step = parseInt(radio.dataset.step);
    
    // Get variant data from radio button
    const variantId = radio.dataset.variantId === 'none' ? null : parseInt(radio.dataset.variantId);
    const variantPrice = parseInt(radio.dataset.variantPrice);
    const variantTitle = radio.dataset.variantTitle;
    const variantImage = radio.dataset.variantImage;
    const compositeImage = radio.dataset.compositeImage;
    const compositeImageWithoutForend = radio.dataset.compositeImageWithoutForend;
    const variantSKU = radio.dataset.variantSku;
    const variantInventory = parseInt(radio.dataset.variantInventory) || 0;
    
    // Get the selected color for this step
    const stepElement = radio.closest('.configurator-step');
    const selectedColorRadio = stepElement.querySelector('.color-radio:checked');
    const colorName = selectedColorRadio ? selectedColorRadio.value : '';
    
    // Store the selection (null for "none" selections)
    if (variantId === null) {
      this.selections[step] = null;
      // Show all colors when "None" is selected
      const stepElement = this.form.querySelector(`[data-step="${step}"]`);
      if (stepElement) {
        const colorOptions = stepElement.querySelectorAll('.color-option');
        colorOptions.forEach(colorOption => {
          colorOption.style.display = 'flex';
        });
      }
    } else {
      this.selections[step] = {
        variantId: variantId,
        price: variantPrice,
        title: variantTitle,
        image: variantImage,
        compositeImage: compositeImage,
        compositeImageWithoutForend: compositeImageWithoutForend,
        color: colorName,
        sku: variantSKU,
        inventory: variantInventory
      };
      
      // Update available colors based on selected variant
      this.updateAvailableColors(step, variantSKU);
    }
    
    // Update composite layer for this step
    if (this.mainImageContainer) {
      const stepLayerMap = {
        1: 'chassis',
        2: 'interface',
        3: 'buttstock',
        4: 'grip',
        5: 'forend'
      };
      
      const layerName = stepLayerMap[step];
      const missingOverlay = this.mainImageContainer.querySelector('.composite-layer-missing');
      const loadingIndicator = this.mainImageContainer.querySelector('.composite-image-loading');
      
      if (layerName) {
        const layer = this.mainImageContainer.querySelector(`[data-layer="${layerName}"]`);
        
        if (variantId === null) {
          // "None" selected - hide overlays and restore placeholder for optional steps (3-5)
          if (missingOverlay) {
            missingOverlay.style.display = 'none';
          }
          if (loadingIndicator) {
            loadingIndicator.style.display = 'none';
          }
          
          // For optional steps (3-5), restore the placeholder image
          if (step >= 3 && layer.dataset.placeholder) {
            layer.src = layer.dataset.placeholder;
            layer.style.display = 'block';
          }
        } else if (compositeImage && compositeImage !== '') {
          // Special logic for chassis (step 1): choose image based on step 5 selection
          let imageToUse = compositeImage;
          if (step === 1) {
            const step5Selection = this.selections[5];
            const hasForendSelected = step5Selection && step5Selection.variantId;
            
            // Use image_without_forend if step 5 is empty/none
            if (!hasForendSelected && compositeImageWithoutForend && compositeImageWithoutForend !== '') {
              imageToUse = compositeImageWithoutForend;
            }
          }
          
          // Has valid image - show loading indicator, then load image
          if (loadingIndicator) {
            loadingIndicator.style.display = 'block';
          }
          if (missingOverlay) {
            missingOverlay.style.display = 'none';
          }
          
          // Create a new image to preload
          const tempImg = new Image();
          tempImg.onload = () => {
            layer.src = imageToUse;
            layer.style.display = 'block';
            if (loadingIndicator) {
              loadingIndicator.style.display = 'none';
            }
          };
          tempImg.onerror = () => {
            // Image failed to load - show missing overlay
            if (loadingIndicator) {
              loadingIndicator.style.display = 'none';
            }
            if (missingOverlay) {
              missingOverlay.style.display = 'block';
            }
          };
          tempImg.src = imageToUse;
        } else {
          // Missing image - flash overlay to show action was taken
          if (loadingIndicator) {
            loadingIndicator.style.display = 'none';
          }
          if (missingOverlay) {
            // Only flash if overlay is already visible
            const wasVisible = missingOverlay.style.display === 'block';
            missingOverlay.style.display = 'none';
            setTimeout(() => {
              missingOverlay.style.display = 'block';
            }, wasVisible ? 100 : 0);
          }
        }
      }
    }
    
    // If Step 1 was changed, check if current Step 2 is compatible
    if (step === 1 && variantSKU) {
      this.ensureCompatibleStep2(variantSKU);
      // Update forend position based on new chassis selection
      this.updateForendPosition();
    }

    // Custom rule: Step 2 SKU adjustment for buttstock position
    if (step === 2) {
      let shiftAmount = 0;
      if (variantSKU === '114469-BLK' || variantSKU === '114469-FDE') {
        shiftAmount = 24;
      } else if (variantSKU === '114622-BLK' || variantSKU === '114622-FDE') {
        shiftAmount = 21;
      } else if (variantSKU === '114597-BLK' || variantSKU === '114597-FDE') {
        shiftAmount = 15;
      }
      this.updateButtstockPosition(shiftAmount);
      // Update grip position based on new interface selection
      this.updateGripPosition();
    }

    // Custom rule: changing Step 2 clears STS buttstock selection in Step 3
    if (step === 2) {
      const step3Selection = this.selections[3];
      const hasSTSButtstockSelected = step3Selection && step3Selection.sku && (step3Selection.sku === '114453-BLK' || step3Selection.sku === '114453-FDE');

      if (hasSTSButtstockSelected) {
        const step3Element = this.form.querySelector('[data-step="3"]');
        if (step3Element) {
          const noneVariant = step3Element.querySelector('.variant-radio[value="none"]');
          if (noneVariant && !noneVariant.checked) {
            noneVariant.checked = true;
            noneVariant.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    }

    // Custom rule: changing Step 3 away from 106418-FDE/106418-BLK clears dependent Step 4 SKUs
    if (step === 3) {
      const step3AllowsRestrictedStep4 = variantSKU === '106418-FDE' || variantSKU === '106418-BLK';

      if (!step3AllowsRestrictedStep4) {
        const step4Selection = this.selections[4];
        const hasRestrictedStep4Selected = step4Selection && step4Selection.sku && (step4Selection.sku === '106794-BLK' || step4Selection.sku === '105945-BLK');

        if (hasRestrictedStep4Selected) {
          const step4Element = this.form.querySelector('[data-step="4"]');
          if (step4Element) {
            const noneVariant = step4Element.querySelector('.variant-radio[value="none"]');
            if (noneVariant && !noneVariant.checked) {
              noneVariant.checked = true;
              noneVariant.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      }
    }
    
    // If Step 5 (forend) changed, refresh the chassis image to use correct version
    if (step === 5) {
      this.refreshChassisImage();
      // Update forend position based on current chassis selection
      this.updateForendPosition();
    }
    
    // Custom rule #1: STS Buttstock removes grip and resets interface
    // If Step 3 (buttstock) with SKU 114453-BLK or 114453-FDE is selected, remove grip (step 4) and interface (step 2)
    if (step === 3 && variantSKU && (variantSKU === '114453-BLK' || variantSKU === '114453-FDE')) {
      // Clear step 2 (interface) selection
      const step2Element = this.form.querySelector('[data-step="2"]');
      if (step2Element) {
        const variantRadios = step2Element.querySelectorAll('.variant-radio');
        variantRadios.forEach(radio => {
          radio.checked = false;
        });
        this.selections[2] = null;
        
        // Reset the interface layer to placeholder
        if (this.mainImageContainer) {
          const layer = this.mainImageContainer.querySelector('[data-layer="interface"]');
          if (layer && layer.dataset.placeholder) {
            layer.src = layer.dataset.placeholder;
            layer.style.display = 'block';
          }
        }
      }
      
      // Clear step 4 (grip) selection
      const step4Element = this.form.querySelector('[data-step="4"]');
      if (step4Element) {
        const noneVariant = step4Element.querySelector('.variant-radio[value="none"]');
        if (noneVariant && !noneVariant.checked) {
          noneVariant.checked = true;
          noneVariant.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      
      // Show flash message
      this.showFlashMessage('STS Buttstock added. Interface and Grip have been cleared. Please select your interface.');
    }
    
    // Filter all steps based on incompatibilities with current selections
    this.filterIncompatibleVariants();
    
    this.updateSummary();
  }
  
  ensureCompatibleStep2(step1SKU) {
    // Check if current Step 2 selection is compatible with new Step 1 selection
    const step2Selection = this.selections[2];
    
    if (!step2Selection || !step2Selection.sku) {
      // No Step 2 selected, nothing to do
      return;
    }
    
    const step2SKU = step2Selection.sku;
    
    // Check if step1 and step2 are incompatible (bidirectional)
    let isIncompatible = false;
    
    // Forward check: does step1 list step2 as incompatible?
    const step1Entry = this.compatibilityData.find(entry => entry.sku === step1SKU);
    if (step1Entry && step1Entry.incompatible_with) {
      const step1IncompatibleSKUs = step1Entry.incompatible_with
        .split(',')
        .map(sku => sku.trim())
        .filter(sku => sku.length > 0);
      isIncompatible = step1IncompatibleSKUs.includes(step2SKU);
    }
    
    // Reverse check: does step2 list step1 as incompatible?
    if (!isIncompatible) {
      const step2Entry = this.compatibilityData.find(entry => entry.sku === step2SKU);
      if (step2Entry && step2Entry.incompatible_with) {
        const step2IncompatibleSKUs = step2Entry.incompatible_with
          .split(',')
          .map(sku => sku.trim())
          .filter(sku => sku.length > 0);
        isIncompatible = step2IncompatibleSKUs.includes(step1SKU);
      }
    }
    
    if (isIncompatible) {
      console.log(`Step 2 (${step2SKU}) is incompatible with new Step 1 (${step1SKU}), auto-selecting compatible Step 2`);
      
      // Find the Step 2 element
      const step2Element = this.form.querySelector('[data-step="2"]');
      if (!step2Element) return;
      
      // Get current color selection for Step 2
      const step2ColorRadio = step2Element.querySelector('.color-radio:checked');
      if (!step2ColorRadio) return;
      
      const colorHandle = step2ColorRadio.value.toLowerCase().replace(/\s+/g, '-');
      const step2VariantGroup = step2Element.querySelector(`[data-color-group="${colorHandle}"]`);
      if (!step2VariantGroup) return;
      
      // Find first compatible variant in the same color group
      const step2Variants = step2VariantGroup.querySelectorAll('.variant-radio');
      let foundCompatible = false;
      
      for (const variantRadio of step2Variants) {
        const candidateSKU = variantRadio.dataset.variantSku;
        if (!candidateSKU) continue;
        
        // Check if this candidate is compatible with step1
        let candidateIsIncompatible = false;
        
        // Forward: does step1 list candidate as incompatible?
        if (step1Entry && step1Entry.incompatible_with) {
          const step1IncompatibleSKUs = step1Entry.incompatible_with
            .split(',')
            .map(sku => sku.trim())
            .filter(sku => sku.length > 0);
          candidateIsIncompatible = step1IncompatibleSKUs.includes(candidateSKU);
        }
        
        // Reverse: does candidate list step1 as incompatible?
        if (!candidateIsIncompatible) {
          const candidateEntry = this.compatibilityData.find(entry => entry.sku === candidateSKU);
          if (candidateEntry && candidateEntry.incompatible_with) {
            const candidateIncompatibleSKUs = candidateEntry.incompatible_with
              .split(',')
              .map(sku => sku.trim())
              .filter(sku => sku.length > 0);
            candidateIsIncompatible = candidateIncompatibleSKUs.includes(step1SKU);
          }
        }
        
        if (!candidateIsIncompatible) {
          // Found a compatible variant, select it
          variantRadio.checked = true;
          variantRadio.dispatchEvent(new Event('change', { bubbles: true }));
          foundCompatible = true;
          console.log(`Auto-selected compatible Step 2: ${candidateSKU}`);
          break;
        }
      }
      
      if (!foundCompatible) {
        console.warn('No compatible Step 2 variant found in current color');
      }
    }
  }

  handleClearSelection(event) {
    const button = event.target;
    const step = parseInt(button.dataset.step);
    
    // Find the step element
    const stepElement = this.form.querySelector(`[data-step="${step}"]`);
    if (!stepElement) return;
    
    // Uncheck all variant radios for this step
    const variantRadios = stepElement.querySelectorAll('.variant-radio');
    variantRadios.forEach(radio => {
      radio.checked = false;
    });
    
    // Clear the selection in the selections object
    this.selections[step] = null;
    
    // Reset the composite layer for this step to placeholder
    if (this.mainImageContainer) {
      const stepLayerMap = {
        1: 'chassis',
        2: 'interface',
        3: 'buttstock',
        4: 'grip',
        5: 'forend'
      };
      
      const layerName = stepLayerMap[step];
      if (layerName) {
        const layer = this.mainImageContainer.querySelector(`[data-layer="${layerName}"]`);
        if (layer && layer.dataset.placeholder) {
          layer.src = layer.dataset.placeholder;
          layer.style.display = 'block';
        }
      }
    }
    
    // Update compatibility filtering
    this.filterIncompatibleVariants();
    
    // Update summary
    this.updateSummary();
  }
  
  filterIncompatibleVariants() {
    // Collect all currently selected variant SKUs (excluding "none")
    const selectedSKUs = [];
    for (let step = 1; step <= 5; step++) {
      const selection = this.selections[step];
      if (selection && selection.sku) {
        selectedSKUs.push(selection.sku);
      }
    }
    
    console.log('Selected SKUs:', selectedSKUs);
    
    // Build a list of all SKUs that are incompatible with any selected SKU
    const allIncompatibleSKUs = new Set();
    selectedSKUs.forEach(selectedSKU => {
      const compatibilityEntry = this.compatibilityData.find(entry => entry.sku === selectedSKU);
      if (compatibilityEntry && compatibilityEntry.incompatible_with) {
        const incompatibleSKUs = compatibilityEntry.incompatible_with
          .split(',')
          .map(sku => sku.trim())
          .filter(sku => sku.length > 0);
        
        incompatibleSKUs.forEach(sku => allIncompatibleSKUs.add(sku));
      }
    });
    
    console.log('All incompatible SKUs:', Array.from(allIncompatibleSKUs));
    
    // If no selections, remove all incompatible states
    if (selectedSKUs.length === 0) {
      const allOptions = this.form.querySelectorAll('.variant-option:not(.variant-option-none)');
      allOptions.forEach(option => {
        option.classList.remove('incompatible');
        const input = option.querySelector('.variant-radio');
        if (input) {
          input.disabled = false;
        }
        const overlay = option.querySelector('.variant-incompatible-overlay');
        if (overlay) {
          overlay.remove();
        }
      });
      return;
    }
    
    // Check if STS Buttstock is selected in Step 3
    const step3Selection = this.selections[3];
    const hasSTSButtstockSelected = step3Selection && step3Selection.sku && 
      (step3Selection.sku === '114453-BLK' || step3Selection.sku === '114453-FDE');
    
    // Check all variant options in all steps
    for (let step = 1; step <= 5; step++) {
      // Skip filtering for Step 1 UNLESS STS Buttstock is selected in Step 3
      // This allows users to freely change chassis selection, except when it would break STS compatibility
      if (step === 1 && !hasSTSButtstockSelected) {
        // Clear any previously applied incompatible states from Step 1
        const stepElement = this.form.querySelector(`[data-step="${step}"]`);
        if (stepElement) {
          const variantOptions = stepElement.querySelectorAll('.variant-option:not(.variant-option-none)');
          variantOptions.forEach(option => {
            option.classList.remove('incompatible');
            const input = option.querySelector('.variant-radio');
            if (input) {
              input.disabled = false;
            }
            const overlay = option.querySelector('.variant-incompatible-overlay');
            if (overlay) {
              overlay.remove();
            }
          });
        }
        continue;
      }
      
      const stepElement = this.form.querySelector(`[data-step="${step}"]`);
      if (!stepElement) continue;
      
      const variantOptions = stepElement.querySelectorAll('.variant-option:not(.variant-option-none)');
      
      variantOptions.forEach(option => {
        const input = option.querySelector('.variant-radio');
        if (!input) return;
        
        const variantSKU = input.dataset.variantSku;
        if (!variantSKU) return;
        
        // Check if this variant's SKU is in the incompatible list (forward check)
        let isIncompatible = allIncompatibleSKUs.has(variantSKU);
        
        // Also check reverse: if any selected SKU appears in THIS variant's incompatibility list (bidirectional)
        if (!isIncompatible) {
          const variantCompatibilityEntry = this.compatibilityData.find(entry => entry.sku === variantSKU);
          if (variantCompatibilityEntry && variantCompatibilityEntry.incompatible_with) {
            const variantIncompatibleSKUs = variantCompatibilityEntry.incompatible_with
              .split(',')
              .map(sku => sku.trim())
              .filter(sku => sku.length > 0);
            
            // Check if any selected SKU is in this variant's incompatibility list
            isIncompatible = selectedSKUs.some(selectedSKU => 
              variantIncompatibleSKUs.includes(selectedSKU)
            );
          }
        }
        
        // Custom rule #2: Conditional compatibility for specific Step 4 SKUs
        // For SKUs 106794-BLK and 105945-BLK (step 4), check additional conditions
        if (!isIncompatible && step === 4 && (variantSKU === '106794-BLK' || variantSKU === '105945-BLK')) {
          const step2Selection = this.selections[2];
          const step3Selection = this.selections[3];
          
          // Define allowed SKUs
          const allowedStep2SKUs = ['110085-BLK', '110085-FDE', '114597-FDE', '114597-BLK', '114622-BLK', '114622-FDE'];
          const allowedStep3SKUs = ['106418-FDE', '106418-BLK'];
          
          // Check if step 2 (buttstock interface) is one of the allowed SKUs
          const step2Compatible = step2Selection && step2Selection.sku && allowedStep2SKUs.includes(step2Selection.sku);
          
          // Check if step 3 (buttstock) is one of the allowed SKUs
          const step3Compatible = step3Selection && step3Selection.sku && allowedStep3SKUs.includes(step3Selection.sku);
          
          // Mark as incompatible if BOTH conditions are not met
          if (!step2Compatible || !step3Compatible) {
            isIncompatible = true;
            console.log(`${variantSKU} is incompatible: requires specific Step 2 and Step 3 selections`);
          }
        }
        
        if (isIncompatible) {
          console.log(`Marking ${variantSKU} as incompatible`);
          option.classList.add('incompatible');
          input.disabled = true;
          
          // Add overlay message if it doesn't exist
          let overlay = option.querySelector('.variant-incompatible-overlay');
          if (!overlay) {
            overlay = document.createElement('div');
            overlay.className = 'variant-incompatible-overlay';
            overlay.textContent = 'Incompatible with current configuration';
            option.appendChild(overlay);
          }
          
          // If this incompatible variant was selected, clear the selection
          if (input.checked) {
            input.checked = false;
            this.selections[step] = null;
          }
        } else {
          option.classList.remove('incompatible');
          input.disabled = false;
          
          // Remove overlay if it exists
          const overlay = option.querySelector('.variant-incompatible-overlay');
          if (overlay) {
            overlay.remove();
          }
        }
      });
    }
    
    this.updateSummary();
  }
  
  updateSummary() {
    // Clear current summary
    this.summaryItems.innerHTML = '';
    
    let totalPrice = 0;
    let hasRequiredSelections = true;
    let itemCount = 0;
    
    // STS Buttstock (114453-BLK / 114453-FDE) has its own interface, so step 2 is not required
    const step3SKU = this.selections[3] && this.selections[3].sku;
    const isSTSButtstockSelected = step3SKU === '114453-BLK' || step3SKU === '114453-FDE';

    // Check required steps (1 and 2, unless STS Buttstock is selected)
    if (!this.selections[1] || (!isSTSButtstockSelected && !this.selections[2])) {
      hasRequiredSelections = false;
    }
    
    // Build summary items
    for (let step = 1; step <= 5; step++) {
      const selection = this.selections[step];
      
      if (selection) {
        itemCount++;
        totalPrice += selection.price;
        
        const itemElement = document.createElement('div');
        itemElement.className = 'summary-item';
        
        const titleWithColor = selection.color && selection.color !== 'none' 
          ? `${selection.title} - ${selection.color}`
          : selection.title;
        
        const stockStatus = selection.inventory > 0 ? 'In Stock' : 'Backorder';
        const stockClass = selection.inventory > 0 ? 'in-stock' : 'backorder';
        itemElement.innerHTML = `
          <div class="summary-item-info">
            <div class="summary-item-title">${titleWithColor}</div>
            <div class="summary-item-meta">SKU: ${selection.sku} • <span class="stock-status ${stockClass}">${stockStatus}</span></div>
          </div>
          <div class="summary-item-price">${this.formatMoney(selection.price)}</div>
        `;
        
        this.summaryItems.appendChild(itemElement);
      }
    }
    
    // Show empty message if no selections
    if (itemCount === 0) {
      this.summaryItems.innerHTML = '<p class="summary-empty">Please select your required options to continue</p>';
    }
    
    // Update total price
    this.totalPrice.textContent = this.formatMoney(totalPrice);
    
    // Enable/disable add to cart button
    this.addToCartBtn.disabled = !hasRequiredSelections;
  }
  
  async handleAddToCart() {
    // Hide any previous errors
    this.errorMessage.style.display = 'none';
    this.errorMessage.textContent = '';
    
    // Check if required steps are selected
    // STS Buttstock (114453-BLK / 114453-FDE) has its own interface, so step 2 is not required
    const step3SKU = this.selections[3] && this.selections[3].sku;
    const isSTSButtstockSelected = step3SKU === '114453-BLK' || step3SKU === '114453-FDE';
    if (!this.selections[1] || (!isSTSButtstockSelected && !this.selections[2])) {
      this.showError('Please select all required options (Steps 1 and 2) before adding to cart.');
      return;
    }
    
    // Collect all variant IDs to add to cart
    const items = [];
    for (let step = 1; step <= 5; step++) {
      const selection = this.selections[step];
      if (selection) {
        items.push({
          id: selection.variantId,
          quantity: 1
        });
      }
    }
    
    if (items.length === 0) {
      this.showError('Please select at least the required options.');
      return;
    }
    
    // Show loading state
    this.addToCartBtn.classList.add('loading');
    this.addToCartBtn.disabled = true;
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Failed to add items to cart');
      }
      
      const data = await response.json();
      
      // Trigger cart update event
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      // Redirect to cart
      window.location.href = '/cart';
      
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.showError(error.message || 'There was an error adding items to your cart. Please try again.');
      
      // Remove loading state
      this.addToCartBtn.classList.remove('loading');
      this.addToCartBtn.disabled = false;
    }
  }
  
  showError(message) {
    this.errorMessage.textContent = message;
    this.errorMessage.style.display = 'block';
  }

  refreshChassisImage() {
    // Only refresh if step 1 (chassis) has a selection
    const step1Selection = this.selections[1];
    if (!step1Selection) return;
    
    const step5Selection = this.selections[5];
    const hasForendSelected = step5Selection && step5Selection.variantId;
    
    // Determine which image to use
    let imageToUse = step1Selection.compositeImage;
    if (!hasForendSelected && step1Selection.compositeImageWithoutForend && step1Selection.compositeImageWithoutForend !== '') {
      imageToUse = step1Selection.compositeImageWithoutForend;
    }
    
    // Update the chassis layer if we have an image
    if (imageToUse && imageToUse !== '' && this.mainImageContainer) {
      const chassisLayer = this.mainImageContainer.querySelector('[data-layer="chassis"]');
      const loadingIndicator = this.mainImageContainer.querySelector('.composite-image-loading');
      const missingOverlay = this.mainImageContainer.querySelector('.composite-layer-missing');
      
      if (chassisLayer) {
        // Show loading indicator
        if (loadingIndicator) {
          loadingIndicator.style.display = 'block';
        }
        if (missingOverlay) {
          missingOverlay.style.display = 'none';
        }
        
        // Preload and update image
        const tempImg = new Image();
        tempImg.onload = () => {
          chassisLayer.src = imageToUse;
          chassisLayer.style.display = 'block';
          if (loadingIndicator) {
            loadingIndicator.style.display = 'none';
          }
        };
        tempImg.onerror = () => {
          // Image failed to load - show missing overlay
          if (loadingIndicator) {
            loadingIndicator.style.display = 'none';
          }
          if (missingOverlay) {
            missingOverlay.style.display = 'block';
          }
        };
        tempImg.src = imageToUse;
      }
    }
  }
  
  showFlashMessage(message, duration = 5000) {
    // Create or reuse flash message element
    let flashMessage = this.mainImageContainer.querySelector('.configurator-flash-message');
    
    if (!flashMessage) {
      flashMessage = document.createElement('div');
      flashMessage.className = 'configurator-flash-message';
      this.mainImageContainer.insertBefore(flashMessage, this.mainImageContainer.firstChild);
    }
    
    // Set message and show
    flashMessage.textContent = message;
    flashMessage.style.display = 'block';
    flashMessage.style.opacity = '1';
    
    // Clear any existing timeouts
    if (this.flashMessageTimeout) {
      clearTimeout(this.flashMessageTimeout);
    }
    
    // Hide after duration
    this.flashMessageTimeout = setTimeout(() => {
      flashMessage.style.opacity = '0';
      setTimeout(() => {
        flashMessage.style.display = 'none';
      }, 300);
    }, duration);
  }
  
  updateButtstockPosition(shiftAmount) {
    // Adjust buttstock layer position based on Step 2 SKU
    const buttstockLayer = this.mainImageContainer.querySelector('[data-layer="buttstock"]');
    if (!buttstockLayer) return;

    if (shiftAmount > 0) {
      // Convert px (calibrated at LAYER_DESIGN_WIDTH) to a fixed % so the shift scales with the container
      const pct = (shiftAmount / ProductConfigurator.LAYER_DESIGN_WIDTH) * 100;
      buttstockLayer.style.transform = `translateX(${pct}%)`;
    } else {
      // Reset to default position
      buttstockLayer.style.transform = 'translateX(0)';
    }
  }
  
  updateForendPosition() {
    // Adjust forend layer position based on Step 1 (chassis) and Step 5 (forend) SKUs
    const forendLayer = this.mainImageContainer.querySelector('[data-layer="forend"]');
    if (!forendLayer) return;
    
    // Get current chassis selection (step 1)
    const step1Selection = this.selections[1];
    if (!step1Selection || !step1Selection.sku) {
      // No chassis selected, reset forend position
      forendLayer.style.transform = 'translateX(0) translateY(0)';
      return;
    }
    
    // Get current forend selection (step 5)
    const step5Selection = this.selections[5];
    if (!step5Selection || !step5Selection.sku) {
      // No forend selected, reset position
      forendLayer.style.transform = 'translateX(0) translateY(0)';
      return;
    }
    
    // Extract SKU prefixes (before the dash)
    const chassisPrefix = step1Selection.sku.split('-')[0];
    const forendPrefix = step5Selection.sku.split('-')[0];
    
    // Determine which config to use (exception for 110071 forend, otherwise default)
    const configKey = forendPrefix === '110071' ? '110071' : 'default';
    const config = this.forendPositionConfig[configKey];
    
    // Get the position adjustment for this chassis
    const position = config[chassisPrefix];
    
    if (position) {
      const xPct = (position.x / ProductConfigurator.LAYER_DESIGN_WIDTH) * 100;
      const yPct = (position.y / ProductConfigurator.LAYER_DESIGN_WIDTH) * 100;
      forendLayer.style.transform = `translateX(${xPct}%) translateY(${yPct}%)`;
    } else {
      // No specific adjustment for this chassis, reset to default
      forendLayer.style.transform = 'translateX(0) translateY(0)';
    }
  }
  
  updateGripPosition() {
    // Adjust grip layer position based on Step 2 (interface) SKU
    const gripLayer = this.mainImageContainer.querySelector('[data-layer="grip"]');
    if (!gripLayer) return;
    
    // Get current interface selection (step 2)
    const step2Selection = this.selections[2];
    if (!step2Selection || !step2Selection.sku) {
      // No interface selected, reset grip position
      gripLayer.style.transform = 'translateX(0) translateY(0)';
      return;
    }
    
    // Extract SKU prefix (before the dash)
    const interfacePrefix = step2Selection.sku.split('-')[0];
    
    // Get the position adjustment for this interface
    const position = this.gripPositionConfig[interfacePrefix];
    
    if (position) {
      const xPct = (position.x / ProductConfigurator.LAYER_DESIGN_WIDTH) * 100;
      const yPct = (position.y / ProductConfigurator.LAYER_DESIGN_WIDTH) * 100;
      gripLayer.style.transform = `translateX(${xPct}%) translateY(${yPct}%)`;
    } else {
      // No specific adjustment for this interface, reset to default
      gripLayer.style.transform = 'translateX(0) translateY(0)';
    }
  }
  
  updateAvailableColors(step, selectedVariantSKU) {
    // Extract the base product identifier from the selected variant's SKU
    // e.g., "114453-BLK" -> "114453"
    const skuPrefix = selectedVariantSKU.split('-')[0];
    
    // Get the color selector for this step
    const stepElement = this.form.querySelector(`[data-step="${step}"]`);
    if (!stepElement) return;
    
    const colorSelector = stepElement.querySelector('[data-step-colors]');
    if (!colorSelector) return;
    
    // Get the variant selector to check which colors have matching variants
    const variantSelector = stepElement.querySelector('[data-step-variants]');
    if (!variantSelector) return;
    
    // For each color option, check if there's a matching variant
    const colorOptions = colorSelector.querySelectorAll('.color-option');
    colorOptions.forEach(colorOption => {
      const colorValue = colorOption.querySelector('.color-radio').value;
      const colorHandle = colorValue.toLowerCase().replace(/\s+/g, '-');
      
      // Find the variant group for this color
      const colorGroup = variantSelector.querySelector(`[data-color-group="${colorHandle}"]`);
      if (!colorGroup) {
        colorOption.style.display = 'none';
        return;
      }
      
      // Check if any variant in this color group has a matching SKU prefix
      const variants = colorGroup.querySelectorAll('.variant-radio');
      let hasMatch = false;
      
      for (const variant of variants) {
        const variantSKU = variant.dataset.variantSku;
        if (variantSKU) {
          const variantSkuPrefix = variantSKU.split('-')[0];
          if (variantSkuPrefix === skuPrefix) {
            hasMatch = true;
            break;
          }
        }
      }
      
      // Show or hide the color option based on whether a match was found
      colorOption.style.display = hasMatch ? 'flex' : 'none';
    });
  }
  
  formatMoney(cents) {
    // Basic money formatting - adjust based on your theme's money format
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }
}

// Container width (px) at which all layer shift values were originally calibrated.
// Adjust this if the desktop values look wrong after testing.
ProductConfigurator.LAYER_DESIGN_WIDTH = 1360;

// Initialize configurator when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductConfigurator();
  });
} else {
  new ProductConfigurator();
}